import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';

import type { State } from '../../types/states';
import { PdfImportEntry } from '../PropertyAdEditor/PdfImportEntry';
import { canUsePdfImport } from '../PropertyAdEditor/pdfImportAccess';
import { Dashboard } from './Dashboard';

export const PdfImportPage = () => {
  const user = useSelector(({ auth }: State) => auth.user);

  return (
    <Dashboard openLogIn>
      {canUsePdfImport(user) ? (
        <PdfImportEntry />
      ) : (
        <Typography role='alert'>PDF import is unavailable for this account.</Typography>
      )}
    </Dashboard>
  );
};
